import { render, staticRenderFns } from "./Seniority.vue?vue&type=template&id=40cee2cc&scoped=true"
import script from "./Seniority.vue?vue&type=script&lang=js"
export * from "./Seniority.vue?vue&type=script&lang=js"
import style0 from "./Seniority.vue?vue&type=style&index=0&id=40cee2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cee2cc",
  null
  
)

export default component.exports